import { render, staticRenderFns } from "./AppLoadingIndicator.vue?vue&type=template&id=5c5a3875"
import script from "./AppLoadingIndicator.vue?vue&type=script&lang=ts"
export * from "./AppLoadingIndicator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports